import React, { useContext } from 'react'
import { Form } from "react-bootstrap"
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { AddProductContext } from '../../App'
import Assets from '../../constants/images'

const SelectImageCard = ({ data }) => {
    const [addProduct, setAddProduct] = useContext(AddProductContext)

    const handleAddOrRemoveProduct = (data) => {
        const index = addProduct.findIndex(product => product.id === data.id);    // return -1 if product is not selected
        if (index === -1) {
            // if product is not selected than add in array
            setAddProduct([
                ...addProduct,
                data
            ])
        }
        else {
            // remove product from array on unselect the post
            addProduct.splice(index, 1)
            setAddProduct([...addProduct])
        }
    }

    const returnCheckedStatus = (data) => {
        const index = addProduct.findIndex(product => product.id === data.id)
        if (index === -1) {
            return false
        }
        else {
            return true
        }
    }

    return (
        <div className='select-img-card'>
            <label htmlFor={data.id}>
                <Form.Check id={data.id} type="checkbox" checked={returnCheckedStatus(data)} />
                <div onClick={() => handleAddOrRemoveProduct(data)}>
                    <img  className='img-fluid' src={data.img} onError={e => e.target.src = Assets.PostImagePlaceholder} alt="" />
                </div>
            </label>
        </div>
    )
}

export default SelectImageCard